var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLoitechDarkBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1900,
    height: 579,
    viewBox: "0 0 1900 579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1900,
    height: 579,
    fill: "#242e45"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-loitech",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-63 -1150.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3008",
    d: "M65,1555.91V1157.15h70.047v398.762Z",
    transform: "translate(0 3.99)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3010",
    d: "M268.266,1214.82c-89.81,0-151.96,69.052-151.96,148.089,0,88.21,67.612,148.978,152.657,148.978,80.713,0,150.754-59.649,150.754-149.168,0-75.277-58.039-147.9-151.452-147.9Zm-.825,67.573c47,0,81.6,36.585,81.6,80.77a80.714,80.714,0,0,1-80.326,81.024c-49.845,0-81.214-39.507-81.214-80.9,0-45.367,35.411-80.9,79.94-80.9Z",
    transform: "translate(46.086 55.79)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3012",
    d: "M440.765,1214.82c-89.81,0-151.96,69.052-151.96,148.089,0,88.21,67.612,148.978,152.657,148.978,80.713,0,150.754-59.649,150.754-149.168,0-52.715-22.829-76.1-22.829-76.1l19.415-6.658v-56.85H489.316a150.1,150.1,0,0,0-48.551-8.286Zm-.825,67.573c47,0,81.6,36.585,81.6,80.77a80.713,80.713,0,0,1-80.326,81.024c-49.845,0-81.214-39.507-81.214-80.9,0-45.367,35.411-80.9,79.941-80.9Z",
    transform: "translate(201.034 55.79)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3014",
    d: "M521.275,1377.49c0,46.848-38.142,81.278-80.326,81.278-49.845,0-81.341-39.888-81.341-81.278H288.545c0,88.21,67.612,148.978,152.657,148.978,80.713,0,150.754-59.459,150.754-148.978Z",
    transform: "translate(200.8 201.909)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3016",
    d: "M463.423,1500.19v-281H533.47v281Z",
    transform: "translate(357.885 59.714)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    d: "M553.93,1541.02V1322.96H516.368v-62.941H553.93v-86.29h70.047v86.29h38.577v62.941H623.978v218.06Z",
    transform: "translate(405.443 18.882)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3020",
    d: "M660.07,511.222a46.385,46.385,0,1,1-46.385-46.385A46.385,46.385,0,0,1,660.07,511.222Z",
    transform: "translate(242.506 687.873)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3022",
    d: "M746.565,1214.72c-90.235,0-148.407,69.088-148.407,150.818,0,84.458,58.365,146.63,149.866,146.63,85.355,0,127.341-53.3,127.341-53.3l-46.825-46.889s-35.355,38.133-79.628,38.133c-36.906,0-66.414-20.6-76.71-58.373H890.466v-19.288c0-76.963-44.546-157.733-143.9-157.733Zm-2.221,61.672c32.268,0,65.269,17.263,72.649,58.5H670.3c5.81-28.987,31.168-58.5,74.045-58.5Z",
    transform: "translate(478.911 55.701)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3024",
    d: "M916.444,1512.23c-90.49,0-152.149-68.921-152.149-150.183,0-83.863,69.686-147.354,151.859-147.354,79.438,0,120.1,56.079,120.1,56.079l-48.864,48.642s-28.306-36.572-71.568-36.572c-47.948,0-80.735,36.68-80.735,80.28,0,46.037,34.876,81.358,80.2,81.358,43.959,0,72.039-36.513,72.039-36.513l49.353,48.617s-40.266,55.646-120.229,55.646Z",
    transform: "translate(628.143 55.681)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3026",
    d: "M921.209,1556.6V1156.62h70.047v146.955s26.821-36.708,85.165-36.708c73.347,0,115.84,54.524,115.84,124.259V1556.6h-70.048V1401.71c0-46.849-29.168-66.286-61.48-66.286-36.815,0-69.478,20.952-69.478,69.912V1556.6Z",
    transform: "translate(769.092 3.512)",
    fill: "#242e45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoitechDarkBlue);
export default __webpack_public_path__ + "static/media/logo-loitech-dark-blue.1aca51479fa5444539f9ab895b6c8f38.svg";
export { ForwardRef as ReactComponent };